export default __webpack_public_path__ + "static/media/image.unicornprofessional-venture.bfe8f375.png";